import React, { useState, useEffect } from "react";
import Datatable from "../../../Components/Datatable"
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../../../context/AuthContext';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import axios from "axios";

export const AdminSubjectList = () => {
    const [data, setData] = useState([]);
    const [passiveData, setpassiveData] = useState([]);

    const [courses, setCourses] = useState([]);
    const [sections, setSections] = useState([]);
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [loadingg, setLoadingg] = useState(true);
    const [loadinggg, setLoadinggg] = useState(true);
    const [msg, setMsg] = useState([]);
    const { user } = useAuth();

    const columns = React.useMemo(
        () => [
            {
                Header: t("subjectName"),
                Footer: t("subjectName"),
                accessor: 'subjectName',
            }
            ,
            {
                Header: t("subjectDescription"),
                Footer: t("subjectDescription"),
                accessor: 'subjectDesc',
            }
            ,
            {
                Header: t("sortid"),
                Footer: t("sortid"),
                accessor: 'sortId',
            }

            ,
            {
                Header: t("courseName"),
                Footer: t("courseName"),
                accessor: 'courseName',
            },
            {
                Header: t("isActive"),
                Footer: t("isActive"),
                accessor: 'isActive',
            },

            {
                Header: t("editSubject"),
                accessor: (originalRow, rowIndex) => (
                    <div className="d-flex  align-items-center">
                        <button
                            className="btn btn-warning mr-2  btn-sm"
                            onClick={() => handleEdit(originalRow)}
                        >
                            {t("edit")}
                        </button>
                    </div>
                ),
                id: 'actionEditSubject',
                Footer: t("editSubject"),
            },

        ],
        [],
    )

    const handleEdit = (row) => {
        window.location.href = "/admin/editsubject/" + row['id'];
    }


    useEffect(() => {
        const fetchsections = async () => {
            setLoadingg(true);

            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                let url = "https://api.heryerdeingilizce.com/api/admin/SectionManager/GetList";

                await axios({
                    method: 'GET',
                    url: url,
                    headers: headerss
                }).then(res => {
                    if (res.status === 200) {
                        for (let i = 0; i < res.data['data'].length; i++) {
                            sections.push({
                                "id": res.data['data'][i]['id'],
                                "sectionName": res.data['data'][i]['sectionName'],
                            })
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            }
            catch (err) {
                setMsg(err);
            }
            setLoadingg(false);
        }
        fetchsections();
        if (loadingg) {
            const fetchcourses = async () => {
                setLoadinggg(true);
                try {
                    const headerss = {
                        "accept": "*/*",
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Credentials': 'false',
                        'Authorization': 'Bearer ' + user.token
                    }
                    let url = "https://api.heryerdeingilizce.com/api/admin/CourseManager/GetCourses";

                    await axios({
                        method: 'GET',
                        url: url,
                        headers: headerss
                    }).then(res => {

                        if (res.status === 200) {

                            if (res.data['success']) {
                                for (let i = 0; i < res.data['data'].length; i++) {
                                    if (res.data['data'][i]['isDeleted'] === false) {
                                        let sectionName = "";
                                        for (let j = 0; j < sections.length; j++) {
                                            if (sections[j]['id'] === res.data['data'][i]['sectionId']) {
                                                sectionName = sections[j]['sectionName'];
                                            }
                                        }
                                        courses.push({
                                            "id": res.data['data'][i]['id'],
                                            "courseName": res.data['data'][i]['courseName'],
                                            "sectionName": sectionName,
                                        })
                                    }
                                }
                            }
                            else {
                                setMsg(res.data['message']);
                            }
                        }
                        else {
                            setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                        }
                    });
                }
                catch (err) {
                    setMsg(err);
                }
                setLoadinggg(false);
            }
            fetchcourses();
        }

        const fetchdata = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                let url = "https://api.heryerdeingilizce.com/api/admin/SubjectManager/GetList";

                await axios({
                    method: 'GET',
                    url: url,
                    headers: headerss
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data['success']) {
                            for (let i = 0; i < res.data['data'].length; i++) {
                                if (res.data['data'][i]['isDeleted'] === false) {
                                    let activity = "";
                                    let courseName = "";
                                    for (let j = 0; j < courses.length; j++) {
                                        if (courses[j]['id'] === res.data['data'][i]['courseId']) {
                                            courseName = courses[j]['courseName'];
                                        }
                                    }
                                    if (res.data['data'][i]['isActive']) {
                                        activity = t('active');
                                        data.push({
                                            "id": res.data['data'][i]['id'],
                                            "subjectName": res.data['data'][i]['subjectName'],
                                            "subjectDesc": res.data['data'][i]['subjectDesc'],
                                            "sortId": res.data['data'][i]['sortId'],
                                            "isActive": activity,
                                            "courseName": courseName,
                                        })
                                    }
                                    else {
                                        activity = t('passive');
                                        passiveData.push({
                                            "id": res.data['data'][i]['id'],
                                            "subjectName": res.data['data'][i]['subjectName'],
                                            "subjectDesc": res.data['data'][i]['subjectDesc'],
                                            "sortId": res.data['data'][i]['sortId'],
                                            "isActive": activity,
                                            "courseName": courseName,
                                        })
                                    }


                                }
                            }
                        }
                        else {
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            }
            catch (err) {
                setMsg(err);
            }
            setLoading(false);
        }
        fetchdata();


    }, [])



    return (
        <div style={{ backgroundColor: "white", width: "full" }} >
            <div style={{ textAlign: "center" }}>
                <h3>{msg}</h3>
                <h1>{t("subjectList")}</h1>
                {loading && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}
                {!loading && (
                    <div>
                        <Datatable data={data} columns={columns} tableBaslik={t("subjectList")} />
                        <br /><hr /><br />
                        <Datatable data={passiveData} columns={columns} tableBaslik={t("passivesubjectList")} />

                    </div>
                )}
            </div>



        </div>
    )
}
export default AdminSubjectList;